"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollHookEventsStatus = exports.PayrollHookEventsType = void 0;
var PayrollHookEventsType;
(function (PayrollHookEventsType) {
    PayrollHookEventsType["OUTBOUND_WEBHOOKS"] = "outbound_webhooks";
    PayrollHookEventsType["DOCUMENT_SIGNATURE"] = "document_signature";
})(PayrollHookEventsType = exports.PayrollHookEventsType || (exports.PayrollHookEventsType = {}));
var PayrollHookEventsStatus;
(function (PayrollHookEventsStatus) {
    PayrollHookEventsStatus["PREPARING"] = "preparing";
    PayrollHookEventsStatus["PENDING"] = "pending";
    PayrollHookEventsStatus["FINISHED"] = "finished";
    PayrollHookEventsStatus["FAILED"] = "failed";
    PayrollHookEventsStatus["CANCELED"] = "canceled";
})(PayrollHookEventsStatus = exports.PayrollHookEventsStatus || (exports.PayrollHookEventsStatus = {}));
